import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIGURATION_TOKEN } from '../app-configuration';
import { ITspDashboardRepository } from './Itsp-dashboard.repository';
import { ApiResponse, Pagination, PatientsAppStatus, SearchPatientResult, SearchResult } from './models';


@Injectable({ providedIn: 'root' })
export class TspDashboardRepository implements ITspDashboardRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly configs = inject(APP_CONFIGURATION_TOKEN);


	patientAppStatusCounts(): Observable<ApiResponse<PatientsAppStatus>> {
		return this.httpClient.get<ApiResponse<PatientsAppStatus>>(this.configs.domainTspAPI + '/api/Dashboard/PatientAppStatusCounts');
	}

	patientAppActivationStatus(activated: boolean, filters: Pagination): Observable<ApiResponse<SearchResult<SearchPatientResult>>> {
		const params = new HttpParams().set('activated', activated);
		return this.httpClient.post<ApiResponse<SearchResult<SearchPatientResult>>>(this.configs.domainTspAPI + '/api/Dashboard/PatientAppActivationStatus', filters, { params });
	}

	patientAppPrescriptionStatus(synchronized: boolean, filters: Pagination): Observable<ApiResponse<SearchResult<SearchPatientResult>>> {
		const params = new HttpParams().set('synchronized', synchronized);
		return this.httpClient.post<ApiResponse<SearchResult<SearchPatientResult>>>(this.configs.domainTspAPI + '/api/Dashboard/PatientAppPrescriptionStatus', filters, { params });
	}

	patientAppStrutAdjustStatus(onSchedule: boolean, filters: Pagination): Observable<ApiResponse<SearchResult<SearchPatientResult>>> {
		const params = new HttpParams().set('onSchedule', onSchedule);
		return this.httpClient.post<ApiResponse<SearchResult<SearchPatientResult>>>(this.configs.domainTspAPI + '/api/Dashboard/PatientAppStrutAdjustStatus', filters, { params });
	}

}
